import { Link, useLocation } from "react-router-dom"
import { Category, Heart, Plus, Search, SmartHome } from "@/components/icons/outline"
import Logo from "@/components/graphics/logo"
import { useAuth } from "@/contexts/auth-context"

export default function Sidebar() {
    // Contexts
    const { user } = useAuth()

    // Hooks
    const url = useLocation().pathname

    return (
        <div className="fixed top-0 flex-col items-center hidden h-full min-h-screen px-2 py-4 md:flex">
            {/* Logo */}
            <Link to="/" className="">
                <Logo className="w-8 h-8" strokeWidth={3} />
            </Link>
            <div className="flex flex-col justify-center flex-grow gap-6 text-neutral-400">
                <Link to="/" className={`relative px-4 py-2 hover:text-black ${url === '/' ? 'text-black' : ''}`}>
                    <SmartHome className="w-7 h-7" strokeWidth={2} />
                </Link>
                {/* <button className="px-4 py-2 text-neutral-600 bg-neutral-200/50 rounded-xl">
                    <Plus className="w-7 h-7" strokeWidth={2} />
                </button> */}
                <Link to="/category" className={`relative px-4 py-2 hover:text-black ${url === '/category' ? 'text-black' : ''}`}>
                    <Category className="w-7 h-7" strokeWidth={2} />
                </Link>
            </div>
            <Link to="/profile" className="relative">
                <img className="w-10 h-10 rounded-full" src={`https://ui-avatars.com/api/?name=${user?.name}`} alt={`${user?.name}'s Profile Picture`} />
            </Link>
        </div>
    )
}